import {qualificationTypes} from "../db/models/const";

export const typeIdToTypeLabel = typeId => {
    if (!typeId) return null;
    const type = qualificationTypes.find(type => type.id === typeId);
    return type ? type.label : "";
}